/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, LinkProps, useLocation } from "react-router-dom";
import { StyledText } from "../assets/typography/typography";
import { colors } from "./colors";
import { useEffect, useState } from "react";

type GoBackLinkButtonProps = {
  to: string;
  text: string;
} & LinkProps;

const goBackLinkContainerStyle = css`
  display: flex;
  flex-direction: row;
  max-width: 1200px;
  width: 100%;
`;

const goBackLinkButtonStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 12px;
  padding-bottom: 12px;
  align-self: flex-start;
  width: max-content;
  min-width: max-content;
  text-decoration: none;
  margin-bottom: 8px;
  gap: 8px;
  color: ${colors.textSecondary};
  border-radius: 4px;
  &:hover {
    color: ${colors.textPrimary};
    text-decoration: none;
  }
`;

export const GoBackLinkButton = ({
  to,
  text,
  ...rest
}: GoBackLinkButtonProps) => {
  const [from, setFrom] = useState(to);
  const location = useLocation();

  useEffect(() => {
    if (!location.state?.from) {
      return;
    }
    setFrom(location.state.from);
  }, [location]);

  return (
    <div css={goBackLinkContainerStyle}>
      <Link to={from} css={goBackLinkButtonStyle} {...rest}>
        <FontAwesomeIcon icon={solid("arrow-left")} />
        <StyledText className="bodyTextSemibold mb-0">{text}</StyledText>
      </Link>
    </div>
  );
};
